import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SccGuard } from './shared/guards/scc.guard';
import { SccPaymentMethodPageComponent } from './components/scc-payment-method-page/scc-payment-method-page.component';
import { SccRegisterModule } from './components/scc-register/scc-register.module';
import { GradientHeaderModule } from '../shared/components/gradient-header/gradient-header.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ModalDialogModule } from '../shared/components/modal-dialog/modal-dialog.module';
import { ModalDialogService } from '../shared/components/modal-dialog/modal-dialog.service';

@NgModule({
  declarations: [
    SccPaymentMethodPageComponent,
  ],
  imports: [
    CommonModule,
    GradientHeaderModule,
    SccRegisterModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    ModalDialogModule,
  ],
  providers : [
    SccGuard,
    ModalDialogService,
  ]
})
export class SccModule { }
